import useTitle from "@/components/hooks/useTitle";
import BodyContent from "@/components/landing-page/BodyContent";
import Footer from "@/components/landing-page/Footer";
import Header from "@/components/landing-page/Header";
import Main from "@/components/landing-page/Main";
import Section from "@/components/landing-page/Section";
import React from "react";
const About = () => {
  const measures = [
    "User’s personal information like password, data source connection credentials are always encrypted and we do not have any access to passwords or data source credentials.",
    "All data is encrypted at rest and our infrastructure is built on Google Cloud Platform. You can read google’s policy for <a href='https://cloud.google.com/docs/security/encryption/default-encryption#:~:text=Google%20encrypts%20all%20customer%20content,one%20or%20more%20encryption%20mechanisms' target='__blank' aria-label='google data encryption policy' class=' underline'>data encryption</a>.",
    "All web communication is secured using HTTPS protocol and server IPs are never exposed to end user and all our services operate behind cloudflare proxies to protect against malicious access.",
    "We only store file data that is uploaded by user and each user has a dedicated separate storage for their files data. On deletion of file or any other data we completely and safely remove it from our servers and databases.",
    "Error logging is implemented for failed requests to improve the product experience and stability.",
    "No table data or query results are stored on our servers.",
    "No Postgres/MySQL data is stored or synced on our servers as we only execute queries for database connections in read only mode.",
    "We take continuous snapshot of our storage for recoverability in the event of server failures in order to provide a seamless product experience to our end users.",
  ];
  const aiMesures = [
    "We use third party AI models like OpenAI, Anthropic Claude (coming soon) for accessing their AI models via API interface we use API access keys issued to Flamingos to access these APIs on behalf of users. You can read their respective privacy policies for an in depth understanding. <a href='https://openai.com/enterprise-privacy' target='__blank' class=' underline' aria-label='OpenAI privacy policy'>OpenAI privacy policy</a>, <a href='https://www.anthropic.com/legal/consumer-terms' target='__blank' class=' underline'  aria-label='Anthropic privacy policy'>Anthropic privacy policy</a>",
    "No chat data, query data or SQL statements are used to train or fine-tune any models at Flamingos. ",
    "However we do have a preferences settings in user settings where a user can opt in for sending their SQL queries to us in order to help us provide a better understanding of how we can improve our AI offering for users at large and to provide a more accurate SQL generation over the time with their consent.",
  ];
  return (
    <React.Fragment>
      <h1 className=" text-center pt-[120px] font-geoGraph font-medium text-[35px] text-[#EDEDED]">
        Privacy Policy
      </h1>
      <div className=" w-[730px] mx-auto text-left text-[15px] font-medium text-[#a9a9a9] font-inter mt-10 antialiased flex flex-col gap-y-[30px]">
        <p>
          At Flamingos we take data security and user information seriously and
          follow good ethics to enable trust for using our product and services.
          Here are the best security measures we have implemented to protect
          your data.
        </p>
        <h2 className=" text-[23px] font-medium antialiased text-[#ededed] text-start">
          Data Security measures :
        </h2>
        <ul className=" list-disc text-start flex flex-col gap-6">
          {measures.map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
          ))}
        </ul>

        <h2 className=" text-[23px] font-medium antialiased text-[#ededed] text-start">
          AI data policy :
        </h2>
        <ul className=" list-disc text-start flex flex-col gap-6">
          {aiMesures.map((item, index) => (
            <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
          ))}
        </ul>
      </div>
      <div className=" w-[730px] mx-auto text-left text-[16px] font-medium text-[#ededed] font-inter mt-[70px] antialiased ">
        <p>
          If you want to know more about how Flamingos works and how it could
          solve some of your problems related to data analytics or data
          management in general you can book a demo call and chat with us.
        </p>
        <br></br>
        <div className=" mt-8 pb-[40px]">
          <button className=" bg-[#ededed] text-black-6 text-[13px] px-4 py-2 rounded-[7px]">
            Schedule a Demo
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
const privacyPolicy = () => {
  useTitle("About");
  return (
    <Main>
      <Header showHero={false}>
        <BodyContent>
          <Section>
            <About />
          </Section>
        </BodyContent>
      </Header>
      <Footer />
    </Main>
  );
};

export default privacyPolicy;
